/*
 * Copyright (c) 2023
 *
 * The source code and all documents related to the source code ("Material") are owned by
 * Frictionless Systems, LLC.
 *
 * The Material contains trade secrets, proprietary information, and confidential information.
 * No part of the Material may be used, copied, reproduced, modified, published, distributed, or
 * disclosed in any way without Frictionless Systems, LLC’s express prior written permission.
 *
 * The Material may be protected under patent, trademark, copyright, or trade secret laws.  No
 * license is granted to you by disclosure or delivery of the Materials.  Any license must be
 * express and approved by Frictionless Systems, LLC in writing.
 *
 * “Frictionless Systems” and “Impulse” are registered trademarks of Frictionless Systems, LLC.
 */

@file:Suppress("ktlint:standard:filename")

package systems.frictionless.impulse.browser.style

import org.jetbrains.compose.web.css.CSSStyleRuleBuilder
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.GenericStyleSheetBuilder
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.marginLeft
import org.jetbrains.compose.web.css.mm
import org.jetbrains.compose.web.css.overflowY
import org.jetbrains.compose.web.css.textDecoration
import org.jetbrains.compose.web.css.width
import systems.frictionless.impulse.browser.style.constants.A
import systems.frictionless.impulse.browser.style.constants.AUTO
import systems.frictionless.impulse.browser.style.constants.HIDDEN
import systems.frictionless.impulse.browser.style.constants.NONE
import systems.frictionless.impulse.browser.style.constants.UNSET
import systems.frictionless.impulse.browser.style.constants.colorBlack
import systems.frictionless.impulse.browser.style.support.boxShadow
import systems.frictionless.impulse.browser.style.support.content
import systems.frictionless.impulse.browser.style.support.height
import systems.frictionless.impulse.browser.style.support.padding
import systems.frictionless.impulse.browser.style.support.width

fun AppStyleSheet.formattingForPrinting(styleSheetBuilder: GenericStyleSheetBuilder<CSSStyleRuleBuilder>) {
    styleSheetBuilder.apply {
        className(contentContainer) style {
            display(DisplayStyle.Block)
            padding("0 !important")
            marginLeft(8.mm) // I was trying also calc((100vh-200mm)/2) but it doesn't work in Safari well.
            width(200.mm)
        }
        className(progressBar) style {
            display(DisplayStyle.None)
        }
        className(navigation) style {
            display(DisplayStyle.None)
        }
        className(insights) style {
            width(AUTO)
        }
        desc(className(insights), desc(className(tabs), className(tabName))) style {
            display(DisplayStyle.None)
        }
        desc(className(insights), className(insightTexts)) style {
            height(AUTO)
            overflowY(HIDDEN)
        }

        className(whiteBox) style {
            boxShadow(UNSET)
        }

        type(A) style {
            textDecoration(NONE)
            color(colorBlack)
        }

        type(A) + after style {
            content(" <\" attr(href) \">")
        }

        // fa is class used in Playground app only
        className("fa") style {
            display(DisplayStyle.None)
        }
    }
}
